<template>
  <div class="invoicelist-cn">
    <div class="datatable-form__header atr-header-wrap mb-4">
      <div class="invoiceList-search_item">
        <label>CreditNote Date</label>
        <el-date-picker
          v-model="inputFromDate"
          type="daterange"
          range-separator="To"
          start-placeholder="From"
          end-placeholder="End"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
        >
        </el-date-picker>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="studName" type="text" placeholder="Student Name"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="studNO" type="text" placeholder="Student NO"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="invName" type="text" placeholder="Invoice NO"></el-input>
      </div>
      <div class="datatable-form__submit text-center">
        <button class="btn btn-success searchbtn" id="btnReceiptSearch" v-on:click="Search('cn')">Search</button>
      </div>
    </div>
    <div class="">
      <div class="datatable-form__submit text-right"></div>
      <div class="pb-5">
        <el-tabs v-model="cnTab" type="card">
          <el-tab-pane label="CN List" name="first">
            <div class="empty-list_image" v-if="CNListInt.length < 1">
              <strong>{{ startupText }}</strong>
              <img src="../../assets/notfound.png" />
            </div>
            <div v-if="CNListInt.length > 0" class="datatable_group">
              <div>
                <el-button-group class="pull-right mb-3">
                  <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAsZip()">Download</el-button>
                  <el-button size="small" type="warning" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAllAsZip()"
                    >Download All CN</el-button
                  >
                </el-button-group>
              </div>
              <data-tables
                :data="CNListInt"
                :action-col="CNListAction"
                @selection-change="changeSelection"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="CNListTable"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column v-for="item in CNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
          <el-tab-pane label="CN List Without Email" name="second">
            <div class="empty-list_image" v-if="CNListWithoutPayeeEmailInt.length < 1">
              <strong>{{ startupText }}</strong>
              <img src="../../assets/notfound.png" />
            </div>
            <div v-if="CNListWithoutPayeeEmailInt.length > 0" class="datatable_group">
              <h5 class="text-left mb-3">CN List Without Email(Please take note)</h5>
              <data-tables :data="CNListWithoutPayeeEmailInt" width="55" stripe tooltip-effect="light" border ref="InvoiceListWithoutPayerEmailTable">
                <el-table-column v-for="item in CNListWithoutPayeeEmail" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <b-modal id="showBatchEmailConfirmationModal" hide-footer title="Send Email Confirmation" size="sm" ref="showBatchEmailConfirmationModal">
      <data-tables :data="selectedCNListInt" v-if="selectedCNListInt.length > 0" width="55" stripe tooltip-effect="light" border ref="selectedListTable">
        <el-table-column v-for="item in selectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmail('No')">No</el-button>
      </div>
    </b-modal>
    <b-modal
      id="showBatchEmailConfirmationModalWithBreakdown"
      hide-footer
      title="Send Email Confirmation With Breakdown"
      size="sm"
      ref="showBatchEmailConfirmationModalWithBreakdown"
    >
      <data-tables :data="selectedCNListInt" v-if="selectedCNListInt.length > 0" width="55" stripe tooltip-effect="light" border ref="selectedListTable">
        <el-table-column v-for="item in selectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmailWithBreakdown()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmailWithBreakdown('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: start-->
    <b-modal id="showTestingBModal" hide-footer title="Send Email Confirmation(TEST ONLY!)" size="sm" ref="showTestingBModal">
      <data-tables
        :data="testingselectedCNListInts"
        v-if="testingselectedCNListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in testingSelectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
        <el-table-column label="Email(TEST)" min-width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.newTestEmail" type="text" placeholder="Email(Key in test email)"></el-input>
          </template>
        </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: end-->
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import moment from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'InvoiceList-CN',
  data() {
    return {
      startupText: '',
      inputFromDate: [],
      inputFromDueDate: [],
      studName: '',
      studNO: '',
      invName: '',
      cnTab: 'first',

      currentSchoolID: '',

      //CNList:start
      CNListAction: {
        label: 'Info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: '',
          },
        ],
      },
      CNListInt: [],
      CNList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'Amount',
          label: 'Amount',
        },
        {
          prop: 'GstAmount',
          label: 'Gst',
        },
        {
          prop: 'TotalAmountIncGst',
          label: 'TotalIncGst',
        },
        {
          prop: 'IH_Invoice_Status',
          label: 'Invoice Status',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Credit Note No',
        },
        {
          prop: 'IH_Invoice_Type',
          label: 'Invoice Type',
        },
        {
          prop: 'IH_Invoice_Name',
          label: 'Invoice No',
        },
        {
          prop: 'email',
          label: 'Payee Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],

      CNListWithoutPayeeEmailInt: [],
      CNListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'IH_Invoice_Status',
          label: 'Invoice Status',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Credit Note No',
        },
        {
          prop: 'IH_Invoice_Name',
          label: 'Invoice No',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
      ],
      CNListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //CNList:end

      tempResp: [],
      spdSelection: [],
      zipType: '',
      selectedCNListInt: [],
      testingselectedCNListInts: [],
      testingSelectedCNList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'IH_Invoice_Status',
          label: 'Invoice Status',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Invoice Name',
        },
        {
          prop: 'email',
          label: 'Email(Key in your testing email)',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      AuditDisabled: false,
    }
  },
  mounted() {
    this.initEvent()
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  props: ['propCNListInt', 'propCurrentSchoolID', 'propCNListWithoutPayeeEmailInt', 'propZipType', 'propSpdSelection'],
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initEvent() {
      this.CNListInt = this.propCNListInt
      this.currentSchoolID = this.propCurrentSchoolID
      this.CNListWithoutPayeeEmailInt = this.propCNListWithoutPayeeEmailInt
      this.zipType = this.propZipType
      this.spdSelection = this.propSpdSelection
      console.log(this.zipType)
    },
    async Search(type) {
      try {
        this.clearTablesList()
        this.clearBModalList()
        //todo: to check empty input, force to input at least 1 datetime
        if (this.inputFromDate.length < 1 && this.inputFromDueDate.length < 1 && !this.studName && !this.studNO && !this.invName) {
          this.$notify.error({
            title: 'Error',
            message: 'Please input at least 1 item!',
          })
        } else {
          this.$vs.loading()
          const resp = await DataSource.shared.getInvoiceCNList(
            this.inputFromDate[0],
            this.inputFromDate[1],
            this.inputFromDueDate[0],
            this.inputFromDueDate[1],
            this.studNO,
            this.invName,
            this.studName,
            type,
          )
          if (resp) {
            if (resp.code === '88') {
              window.location.replace('/')
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Search Student: Error',
              })
            } else if (resp.code === '2') {
              this.$notify.error({
                title: 'No Record',
                message: 'No Student Found',
              })
            } else {
              this.tempResp = resp.Table
              this.tempResp.forEach(m => {
                if (m.email) {
                  this.CNListInt.push(m)
                } else {
                  this.CNListWithoutPayeeEmailInt.push(m)
                }
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async clearTablesList() {
      this.CNListInt = []
      this.CNListWithoutPayeeEmailInt = []
    },
    async clearBModalList() {
      console.log('clearBModalList')
      this.spdSelection = []
      this.selectedCNListInt = []
    },
    async showBModal() {
      try {
        //todo: check if no checkbox selected
        if (this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showBatchEmailConfirmationModal.show()
          await this.getSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async showBModalWithBreakdown() {
      try {
        if (this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showBatchEmailConfirmationModalWithBreakdown.show()
          await this.getSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSelectedList() {
      this.selectedCNListInt = this.spdSelection
    },
    async downloadAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.spdSelection
        if (this.spdSelection.length < 1) {
          alert('Please select at least 1 item!')
        } else {
          this.$vs.loading()
          spdList.forEach(m => {
            let List = {
              IH_Invoice_No: m.IH_Invoice_No,
            }
            selectedObjList.push(List)
          })

          const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Cannot download files!',
            })
          } else {
            let byteChar = atob(resp.code)
            let byteNo = new Array(byteChar.length)
            for (let i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNo)
            let file = new Blob([byteArray], { type: 'application/zip;base64' })
            let fileUrl = URL.createObjectURL(file)
            window.location.href = fileUrl
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async downloadAllAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.CNListInt
        this.$vs.loading()
        spdList.forEach(m => {
          let List = {
            IH_Invoice_No: m.IH_Invoice_No,
          }
          selectedObjList.push(List)
        })

        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot download files!',
          })
        } else {
          let byteChar = atob(resp.code)
          let byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }
          let byteArray = new Uint8Array(byteNo)
          let file = new Blob([byteArray], { type: 'application/zip;base64' })
          let fileUrl = URL.createObjectURL(file)
          window.location.href = fileUrl
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTestingSelectedList() {
      this.testingselectedCNListInt = this.spdSelection
    },
    //Testing items only: start
    async showTestBModal() {
      try {
        //todo: check if no checkbox selected
        if (this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showTestingBModal.show()
          await this.getTestingSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnSendEmail(value) {
      this.$emit('btnSendEmail', value)
    },
    async btnSendEmailWithBreakdown(value) {
      this.$emit('btnSendEmailWithBreakdown', value)
    },
    async btnTestingSendEmail(value) {
      this.$emit('btnTestingSendEmail', value)
    },
    async btnTestingSendEmailWithBreakdown(value) {
      this.$emit('btnTestingSendEmailWithBreakdown', value)
    },
  },
}
</script>
<style scoped></style>
<style></style>
